'use strict';
const React = require('react');
const BaseComponent = require('../../../../../../../shared/base');

class HeaderBookingDetails extends BaseComponent {
    render() {
        return null;
    }
}

module.exports = HeaderBookingDetails;